import React, { useState, useContext, useEffect, useRef } from "react";
import { useParams, useNavigate } from "react-router-dom";

import { motion, AnimatePresence } from "framer-motion";
import _ from "lodash";
import axios from "axios";

import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";
import Stack from "@mui/material/Stack";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";

import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";

import Downloader from "../components/widgets/Downloader";
import Wrapper from "../components/layout/Wrapper";
import CopyToClipboardButton from "../components/widgets/CopyToClipboardButton";
import StandingsSelect from "../components/playerprofiles/StandingsSelect";

import SelectInput from "../components/inputs/SelectInput";
import TextInput from "../components/inputs/TextInput";
import PlayerSelect from "../components/customleaderboard/PlayerSelect";

import NotificationWidget from "../components/widgets/NotificationWidget";

import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import DeleteIcon from "@mui/icons-material/Delete";
import DragIndicatorIcon from "@mui/icons-material/DragIndicator";

import CustomLeaderboardPreview from "../components/customleaderboard/CustomLeaderboardPreview";
import DataGrid from "../components/standings/DataGrid";

//HOOKS
import useCustomLeaderboard from "../hooks/useCustomLeaderboard";
import useStandingsHandler from "../hooks/useStandingsHandler";
import { SocketContext } from "../context/socket";

// MODAL
import Modal from "@mui/material/Modal";

const style = {
   position: "absolute",
   top: "50%",
   left: "50%",
   transform: "translate(-50%, -50%)",
   width: "90%",
   height: "auto",
   maxHeight: "90%",
   overflow: "auto",
   bgcolor: "#444",
   border: "2px solid #000",
   boxShadow: 24,
   p: 4,
};

function TabPanel(props) {
   const { children, value, index, ...other } = props;

   return (
      <div
         role="tabpanel"
         hidden={value !== index}
         id={`leaderboard-tabpanel-${index}`}
         aria-labelledby={`leaderboard-tab-${index}`}
         {...other}
      >
         {value === index && <Box sx={{ pt: 2 }}>{children}</Box>}
      </div>
   );
}

function a11yProps(index) {
   return {
      id: `leaderboard-tab-${index}`,
      "aria-controls": `leaderboard-tabpanel-${index}`,
   };
}

export default function CustomLeaderboard({ parent = "" }) {
   let navigate = useNavigate();
   const socket = useContext(SocketContext);

   const [
      notification,
      all,
      activeData,
      show,
      runTimestamp,
      allPlayers,
      currentPage,
      playlist,
      playlistIndex,
      {
         update,
         add,
         deleteLeaderboard,
         getAll,
         get,
         viewerLoad,
         viewerNextPrev,
         refreshTeams,
         importTeams,
         viewerShowHide,
         subscribeViewer,
         loadAllPlayers,
         getAllPlayers,
         setPage,
         getPlaylist,
         updatePlaylist,
         playlistNext,
         playlistPrev,
         updatePlaylistIndex,
      },
   ] = useCustomLeaderboard();

   const [editRow, setEditRow] = useState(null);
   const [activeTab, setActiveTab] = useState(0);
   const [draggedItem, setDraggedItem] = useState(null);
   const [dragOverIndex, setDragOverIndex] = useState(null);
   const [selectedStandingsRound, setSelectedStandingsRound] = useState(0);
   const [selectedArchetype, setSelectedArchetype] = useState(0); // 0=None, 1=Archetype, 2=Team
   const [selectedRows, setSelectedRows] = useState(8);
   const [selectedColumns, setSelectedColumns] = useState(1);
   const [teamStandings, setTeamStandings] = useState([]);
   const [strixhavenTeamStandings, setStrixhavenTeamStandings] = useState([]);

   // USE STANDINGS HOOK
   const [
      standings,
      setStandings,
      cachedStandings,
      tournamentRounds,
      notificationStandings,
      {
         getCachedStandings,
         getStandings,
      },
   ] = useStandingsHandler();

   useEffect(() => {
      subscribeViewer(1);
      loadAllPlayers();
      getCachedStandings();
   }, []);

   // useEffect(() => {
   //    console.log(activeData);
   // }, [activeData]);

   const columnWidth = useRef();
   const [downloadVisibility, setDownloadVisibility] = useState(false);

   const iframeScale =
      columnWidth.current &&
      (parseInt(window.getComputedStyle(columnWidth.current).width) -
         parseInt(
            window
               .getComputedStyle(columnWidth.current)
               .getPropertyValue("padding-left")
         )) /
      1920;

   // WINDOW LISTENER
   const [windowSize, setWindowSize] = useState({});

   useEffect(() => {
      function handleResize() {
         setWindowSize({
            height: window.innerHeight,
            width: window.innerWidth,
         });
      }

      window.addEventListener("resize", handleResize);

      return (_) => {
         window.removeEventListener("resize", handleResize);
      };
   });

   useEffect(() => {
      setWindowSize({
         height: window.innerHeight,
         width: window.innerWidth,
      });
   }, []);

   useEffect(() => {
      getAll();
      getPlaylist();
   }, []);

   useEffect(() => {
      if (activeTab === 0) {
         getPlaylist();
      }
   }, [activeTab, all]);

   useEffect(() => {
      if (activeTab === 3) {
         // Load most recent standings when ALL PLAYERS tab is selected
         // Always load round 0 (most recent) when tab is first opened
         if (selectedStandingsRound === 0 || selectedStandingsRound === undefined || selectedStandingsRound === null) {
            getStandings(0);
         } else {
            getStandings(selectedStandingsRound);
         }
      }
      const roundId = selectedStandingsRound || 0;
      if (activeTab === 4) {
         socket.emit("getTeamStandings", roundId, "all", (response) => {
            const standings = response?.teamStandings || response || [];
            setTeamStandings(standings);
         });
         setStrixhavenTeamStandings([]);
      } else if (activeTab === 5) {
         socket.emit("getTeamStandings", roundId, "strixhaven", (response) => {
            const standings = response?.teamStandings || response || [];
            setStrixhavenTeamStandings(standings);
         });
         setTeamStandings([]);
      } else {
         setTeamStandings([]);
         setStrixhavenTeamStandings([]);
      }
   }, [activeTab, selectedStandingsRound]);

   useEffect(() => {
      // console.log(all);
   }, [all]);

   const handleLoadSlide = (id, e) => {
      viewerLoad(id, e.target.id);
   };

   const handleShowHide = (id, e) => {
      viewerShowHide(id, e.target.value);
   };

   const handleUpdatePage = (id, e) => {
      setPage(id, e.target.value);
   };

   const handleChangeStandings = (id, e) => {
      update(id, { [e.id]: e.value });
   };

   const handleDelete = (id, title) => {
      if (id) {
         if (
            window.confirm("Are you sure you want to delete '" + title + "'?")
         ) {
            deleteLeaderboard(id);
         }
      }
   };

   const handleTabChange = (event, newValue) => {
      setActiveTab(newValue);
   };

   const handleStandingsChange = (e) => {
      const roundId = e.value;
      setSelectedStandingsRound(roundId);
      // Allow 0 for most recent standings, only skip if null/undefined
      if (roundId !== null && roundId !== undefined) {
         getStandings(roundId);
      } else {
         setStandings([]);
      }
   };

   const handleLoadAllPlayers = (viewerId) => {
      const roundId = selectedStandingsRound || 0;

      // Get all players data for the selected round (top 32)
      socket.emit("getCustomLeaderboardAllPlayers", roundId, (allPlayersData) => {
         console.log("Received allPlayersData:", allPlayersData);
         if (!allPlayersData || allPlayersData.length === 0) {
            alert("No players data available for the selected round.");
            return;
         }

         // Extract player IDs from the standings data
         const playerIds = allPlayersData.map((item) => {
            return item.id || item.PlayerId;
         }).filter(Boolean);
         console.log("Extracted player IDs:", playerIds);

         if (playerIds.length === 0) {
            alert("No player IDs found in standings data.");
            return;
         }

         // Load players directly to viewer with round and archetype
         socket.emit("loadCustomLeaderboardPlayersToViewer", {
            viewerId: viewerId,
            roundId: roundId,
            playerIds: playerIds,
            archetype: selectedArchetype, // 0=None, 1=Archetype, 2=Team, 3=Strixhaven School
            columns: selectedColumns,
            rows: selectedRows
         }, (response) => {
            console.log("Loaded to viewer:", response);
         });
      });
   };

   const handleLoadTeamsToViewer = (viewerId, teamMode = "all", overrideSettings = null) => {
      const roundId = overrideSettings?.roundId !== undefined ? overrideSettings.roundId : (selectedStandingsRound || 0);
      const archetype = overrideSettings?.archetype !== undefined ? overrideSettings.archetype : selectedArchetype;
      const columns = overrideSettings?.columns !== undefined ? overrideSettings.columns : selectedColumns;
      const rows = overrideSettings?.rows !== undefined ? overrideSettings.rows : selectedRows;

      socket.emit("getTeamStandings", roundId, teamMode, (teamStandingsData) => {
         if (!teamStandingsData || (teamStandingsData.teamStandings && teamStandingsData.teamStandings.length === 0) || (Array.isArray(teamStandingsData) && teamStandingsData.length === 0)) {
            alert("No team standings data available for the selected round.");
            return;
         }

         socket.emit("loadCustomLeaderboardTeamsToViewer", {
            viewerId: viewerId,
            roundId: roundId,
            teamStandings: teamStandingsData,
            archetype: archetype,
            columns: columns,
            rows: rows,
            title: teamMode === "strixhaven" ? "STRIXHAVEN SCHOOLS" : "TEAMS",
         }, (response) => {
            console.log("Loaded teams to viewer:", response);
         });
      });
   };

   const handleLoadAllTeams = (viewerId, overrideSettings = null) => {
      handleLoadTeamsToViewer(viewerId, "all", overrideSettings);
   };

   const handleLoadStrixhavenTeamsToViewer = (viewerId, overrideSettings = null) => {
      handleLoadTeamsToViewer(viewerId, "strixhaven", overrideSettings);
   };

   // Filter rows based on Type: 0=storyboard, 1=team, 2=generic standings row, 3=teams placeholder
   // Storyboards tab only shows Type 0 (explicitly, not undefined/null)
   const customRows = all ? all.filter((row) => row.Type === 0) : [];
   const teamRows = all ? all.filter((row) => row.Type === 1).sort((a, b) => {
      const titleA = (a.Title || "").toUpperCase();
      const titleB = (b.Title || "").toUpperCase();
      if (titleA < titleB) return -1;
      if (titleA > titleB) return 1;
      return 0;
   }) : [];
   
   // Get all items for available leaderboards, grouped and sorted
   // Storyboards (Type 0) first, then Teams (Type 1)
   // Exclude Type 2 (standings) from available items
   const availableItems = all ? [...all]
      .filter((item) => item.Type !== 2 && item.Type !== 3) // Exclude Type 2 (standings) and Type 3 (teams placeholder)
      .sort((a, b) => {
         // First, separate by Type: 0 (storyboard) < 1 (team)
         const typeA = a.Type !== undefined && a.Type !== null ? a.Type : 0;
         const typeB = b.Type !== undefined && b.Type !== null ? b.Type : 0;
         if (typeA !== typeB) return typeA - typeB;
         
         // Within same group, sort alphabetically by Title
         const titleA = (a.Title || "").toUpperCase();
         const titleB = (b.Title || "").toUpperCase();
         if (titleA < titleB) return -1;
         if (titleA > titleB) return 1;
         return 0;
      }) : [];

   const handleAddToPlaylist = (item) => {
      const newPlaylist = [...playlist, item];
      updatePlaylist(newPlaylist);
   };

   const handleAddStandingsToPlaylist = () => {
      // Create a placeholder custom leaderboard in the database first
      socket.emit("addCustomLeaderboard", (newLeaderboard) => {
         if (!newLeaderboard || !newLeaderboard.id) {
            alert("Failed to create standings placeholder.");
            return;
         }

         // Update the new leaderboard with STANDINGS placeholder data
         // Use empty PlayerIDs array to identify it as a placeholder
         const updates = {
            Title: "STANDINGS",
            StandingsId: selectedStandingsRound || 0,
            Archetype: selectedArchetype,
            Rows: selectedRows,
            Columns: selectedColumns,
            Type: 2, // 2 = generic standings row
            PlayerIDs: JSON.stringify([]) // Empty player IDs - will be loaded dynamically
         };
         
         // Update the leaderboard
         update(newLeaderboard.id, updates);
         
         // Create the placeholder object with the new leaderboard data
         const standingsPlaceholder = {
            ...newLeaderboard,
            ...updates,
            PlayerIDs: [] // Store as empty array for detection
         };
         
         // Add to playlist
         const newPlaylist = [...playlist, standingsPlaceholder];
         updatePlaylist(newPlaylist);
      });
   };

   const handleAddTeamsToPlaylist = () => {
      // Create a placeholder custom leaderboard in the database first
      socket.emit("addCustomLeaderboard", (newLeaderboard) => {
         if (!newLeaderboard || !newLeaderboard.id) {
            alert("Failed to create teams placeholder.");
            return;
         }

         // Update the new leaderboard with TEAMS placeholder data
         // Use empty PlayerIDs array to identify it as a placeholder
         const updates = {
            Title: "TEAMS",
            StandingsId: selectedStandingsRound || 0,
            Archetype: selectedArchetype,
            Rows: selectedRows,
            Columns: selectedColumns,
            Type: 3, // 3 = teams placeholder row
            PlayerIDs: JSON.stringify([]) // Empty player IDs - will be loaded dynamically
         };
         
         // Update the leaderboard
         update(newLeaderboard.id, updates);
         
         // Create the placeholder object with the new leaderboard data
         const teamsPlaceholder = {
            ...newLeaderboard,
            ...updates,
            PlayerIDs: [] // Store as empty array for detection
         };
         
         // Add to playlist
         const newPlaylist = [...playlist, teamsPlaceholder];
         updatePlaylist(newPlaylist);
      });
   };

   const handleRemoveFromPlaylist = (itemId) => {
      // Check if this is a STANDINGS row (Type 2) or TEAMS row (Type 3) - if so, delete from database
      const itemToRemove = playlist.find(item => item.id === itemId);
      if (itemToRemove && (itemToRemove.Type === 2 || itemToRemove.Type === 3)) {
         // Delete the database record for STANDINGS and TEAMS placeholder rows
         deleteLeaderboard(itemId);
      }
      
      // Remove from playlist
      const newPlaylist = playlist.filter(item => item.id !== itemId);
      updatePlaylist(newPlaylist);
   };

   const handlePlaylistReorder = (newOrder) => {
      updatePlaylist(newOrder);
   };

   const handlePlaylistDragStart = (e, index) => {
      setDraggedItem(index);
      e.dataTransfer.effectAllowed = "move";
      
      // Find the TableRow and use it as the drag image
      const row = e.currentTarget.closest('tr');
      if (row) {
         // Create a clone of the row for the drag image
         const dragImage = row.cloneNode(true);
         const table = document.createElement('table');
         const tbody = document.createElement('tbody');
         tbody.appendChild(dragImage);
         table.appendChild(tbody);
         
         // Style the drag image
         table.style.width = row.offsetWidth + 'px';
         table.style.borderCollapse = 'collapse';
         table.style.backgroundColor = '#efefef';
         table.style.opacity = '0.9';
         table.style.boxShadow = '0 4px 8px rgba(0,0,0,0.3)';
         table.style.border = '1px solid #666';
         
         // Style the row in the drag image
         dragImage.style.backgroundColor = '#efefef';
         
         document.body.appendChild(table);
         table.style.position = 'absolute';
         table.style.top = '-1000px';
         table.style.left = '-1000px';
         
         // Set the drag image offset to center on cursor
         const rect = row.getBoundingClientRect();
         const offsetX = e.clientX - rect.left;
         const offsetY = e.clientY - rect.top;
         
         e.dataTransfer.setDragImage(table, offsetX, offsetY);
         
         // Clean up after a short delay
         setTimeout(() => {
            if (document.body.contains(table)) {
               document.body.removeChild(table);
            }
         }, 0);
      }
   };

   const handlePlaylistDragOver = (e, index) => {
      e.preventDefault();
      e.dataTransfer.dropEffect = "move";
      setDragOverIndex(index);
   };

   const handlePlaylistDragEnd = () => {
      setDraggedItem(null);
      setDragOverIndex(null);
   };

   const handlePlaylistDrop = (e, dropIndex) => {
      e.preventDefault();
      if (draggedItem !== null && draggedItem !== dropIndex) {
         const newPlaylist = [...playlist];
         const [removed] = newPlaylist.splice(draggedItem, 1);
         newPlaylist.splice(dropIndex, 0, removed);
         handlePlaylistReorder(newPlaylist);
      }
      setDraggedItem(null);
      setDragOverIndex(null);
   };

   return (
      <Wrapper>
         <Stack
            direction='row'
            alignItems='center'
            justifyContent='space-between'
         >
            <Typography
               variant='h3'
               component='div'
               sx={{ textTransform: "uppercase", mb: 2 }}
            >
               Standings
            </Typography>

            {/* <Downloader
               enabled={activeData ? true : false}
               downloadName={
                  activeData && activeData.rows && activeData.rows.length > 0
                     ? "Leaderboard-" +
                       activeData.Title +
                       "-" +
                       currentPage +
                       "_" +
                       Date.now()
                     : ""
               }
            >
               <CustomLeaderboardPreview
                  currentPage={currentPage}
                  show={show}
                  activeData={activeData}
                  preview={true}
               />
            </Downloader> */}
         </Stack>

         {/* <Stack direction='row' spacing={2} sx={{ mb: 4 }} justifyContent='space-between' width='100%'>
            <Stack direction='row' spacing={2}>
               <Button
                  variant='outlined'
                  color='warning'
                  sx={{ mr: 2, whiteSpace: "nowrap", px: 4 }}
                  onClick={(e) => viewerNextPrev(1, "prevgroup")}
                  size='small'
               >
                  {"<"} PREV GROUP
               </Button>
               <Button
                  variant='outlined'
                  color='warning'
                  sx={{ mr: 2, whiteSpace: "nowrap", px: 4 }}
                  value={"next"}
                  onClick={(e) => viewerNextPrev(1, "nextgroup")}
                  size='small'
               >
                  NEXT GROUP {">"}
               </Button>
            </Stack>

         </Stack> */}


         <Stack direction='row' spacing={4} height={1080 * iframeScale + 100}>
            <Box
               width='40%'
               ref={columnWidth}
               sx={{
                  height: 1080 * iframeScale,
                  position: "relative",
               }}
            >
               <CustomLeaderboardPreview
                  viewerId={1}
                  handleUpdatePage={handleUpdatePage}
                  iframeScale={iframeScale}
               />
            </Box>

            <Box
               width='40%'
               sx={{
                  height: 1080 * iframeScale,
                  position: "relative",
               }}
            >
               <CustomLeaderboardPreview
                  viewerId={2}
                  handleUpdatePage={handleUpdatePage}
                  iframeScale={iframeScale}
               />
            </Box>
         </Stack>

         <Box sx={{ width: "100%", mt: 4 }}>
            <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
               <Tabs
                  value={activeTab}
                  onChange={handleTabChange}
                  aria-label="leaderboard tabs"
               >
                  <Tab label="PLAYLIST" {...a11yProps(0)} sx={{ mr: 10 }} />
                  <Tab label="STORYBOARDS" {...a11yProps(1)} />
                  <Tab label="TEAMS" {...a11yProps(2)} />
                  <Tab label="ALL PLAYERS" {...a11yProps(3)} />
                  <Tab label="ALL TEAMS" {...a11yProps(4)} />
                  <Tab label="STRIXHAVEN SCHOOLS" {...a11yProps(5)} />
               </Tabs>
            </Box>
            
            <TabPanel value={activeTab} index={0}>
               <Stack 
                  direction={{ xs: 'column', md: 'row' }} 
                  spacing={4} 
                  sx={{ mt: 2 }}
               >
                  {/* Left Column - Playlist */}
                  <Box sx={{ width: { xs: "100%", md: "80%" }, minWidth: 0 }}>
                     <Stack direction='row' alignItems='center' justifyContent='space-between' spacing={1} sx={{ mb: 2 }}>
                        <Stack direction='row' alignItems='center' spacing={2}>
                           <Typography variant='h6' sx={{  textTransform: "uppercase" }}>
                              Playlist
                           </Typography>
                           <Button
                              variant='outlined'
                              color='alert'
                              size='small'
                              onClick={handleAddStandingsToPlaylist}
                           >
                              + ADD STANDINGS ROW
                           </Button>
                        </Stack>
                        
                        <Stack direction='row' spacing={1}>
                           <Button
                              variant='outlined'
                              color='warning'
                              size='small'
                              onClick={playlistPrev}
                              disabled={playlist.length === 0}
                           >
                              PREV
                           </Button>
                           <Button
                              variant='outlined'
                              color='warning'
                              size='small'
                              onClick={playlistNext}
                              disabled={playlist.length === 0}
                           >
                              NEXT
                           </Button>
                           <Typography variant='body2' sx={{ ml: 2, color: "#999" }}>
                              {typeof playlistIndex === "number" && playlist.length > 0 ? `${playlistIndex + 1} / ${playlist.length}` : null}
                           </Typography>
                        </Stack>
                     </Stack>
                     <Box sx={{ overflowX: 'auto', width: '100%' }}>
                        <Table variant='dashboard' sx={{ minWidth: 600 }}>
                           <TableHead>
                              <TableRow>
                                 <TableCell sx={{ py: 1, width: "40px" }}></TableCell>
                                 <TableCell sx={{ py: 1 }}>Title</TableCell>
                                 <TableCell sx={{ py: 1 }}>Settings</TableCell>
                                 <TableCell align='right' sx={{ py: 1 }}>Actions</TableCell>
                              </TableRow>
                           </TableHead>
                        <TableBody>
                           {playlist.length > 0 ? (
                              <>
                                 {playlist.map((item, index) => (
                                    <TableRow
                                       key={item.id}
                                       onDragOver={(e) => handlePlaylistDragOver(e, index)}
                                       onDrop={(e) => handlePlaylistDrop(e, index)}
                                       sx={{
                                          opacity: draggedItem === index ? 0.8 : 1,
                                          backgroundColor: dragOverIndex === index ? "#efefef" : "transparent",
                                          borderLeft: index === playlistIndex ? "6px solid #f44336" : "none",
                                          "&:hover": {
                                             backgroundColor: "#ccc",
                                          },
                                       }}
                                    >
                                       <TableCell 
                                          sx={{ 
                                             py: 1, 
                                             width: "40px",
                                             position: "relative",
                                             zIndex: 1,
                                          }}
                                       >
                                          <Box
                                             component="div"
                                             draggable={true}
                                             onDragStart={(e) => {
                                                handlePlaylistDragStart(e, index);
                                             }}
                                             onDragEnd={(e) => {
                                                e.stopPropagation();
                                                handlePlaylistDragEnd();
                                             }}
                                             onMouseDown={(e) => {
                                                e.stopPropagation();
                                             }}
                                             sx={{
                                                cursor: "grab",
                                                display: "flex",
                                                alignItems: "center",
                                                justifyContent: "center",
                                                position: "relative",
                                                zIndex: 100,
                                                pointerEvents: "auto",
                                                userSelect: "none",
                                                WebkitUserSelect: "none",
                                                touchAction: "none",
                                                "&:active": {
                                                   cursor: "grabbing",
                                                },
                                                "&:hover": {
                                                   opacity: 0.7,
                                                },
                                             }}
                                          >
                                             <DragIndicatorIcon sx={{ color: "#999", fontSize: "1.5rem", pointerEvents: "none" }} />
                                          </Box>
                                       </TableCell>
                                       <TableCell sx={{ py: 1, width: "100%" }}>
                                          <Typography variant='body1' sx={{ fontWeight: "bold" }}>
                                             {item.Title || "-NO TITLE-"}
                                          </Typography>
                                       </TableCell>
                                       <TableCell>
                                          <Stack spacing={1} backgroundColor="white" alignItems="flex-start" justifyContent="center" px={1} py={1}>
                                             <StandingsSelect
                                                selected={item.StandingsId ? item.StandingsId : 0}
                                                callback={(e) => handleChangeStandings(item.id, e)}
                                             />
                                             <Stack direction='row' spacing={1}>
                                                <Select
                                                   value={item.Columns !== undefined && item.Columns !== null ? item.Columns : 1}
                                                   onChange={(e) => update(item.id, { Columns: Number(e.target.value) })}
                                                   size='small'
                                                   sx={{ minWidth: 80 }}
                                                >
                                                   <MenuItem value={1}>Columns: 1</MenuItem>
                                                   <MenuItem value={2}>Columns: 2</MenuItem>
                                                </Select>
                                                {/* If columns > 1, hide archetype select for all types */}
                                                {item.Columns && item.Columns > 1 ? null : (
                                                   <Select
                                                      value={item.Archetype !== undefined && item.Archetype !== null ? item.Archetype : 0}
                                                      onChange={(e) => update(item.id, { Archetype: e.target.value })}
                                                      size='small'
                                                      sx={{ minWidth: 100 }}
                                                   >
                                                      <MenuItem value={0}>{(item.Type === 2 || item.Type === 3) ? "--" : "None"}</MenuItem>
                                                      <MenuItem value={1}>Archetype</MenuItem>
                                                      <MenuItem value={2}>Team</MenuItem>
                                                      <MenuItem value={3}>Strixhaven School</MenuItem>
                                                   </Select>
                                                )}
                                             </Stack>
                                          </Stack>
                                       </TableCell>
                                       <TableCell align='right' sx={{ whiteSpace: "nowrap", py: 1 }}>
                                          <Stack direction='column' spacing={0.5}>
                                             <Button
                                                variant='outlined'
                                                color='success'
                                                size='small'
                                                sx={{ py: 0.5, px: 1 }}
                                                onClick={() => {
                                                   // Check if this is a STANDINGS or TEAMS placeholder (Title === "STANDINGS" or "TEAMS" and empty PlayerIDs)
                                                   const playerIDs = item.PlayerIDs ? (typeof item.PlayerIDs === 'string' ? JSON.parse(item.PlayerIDs) : item.PlayerIDs) : [];
                                                   const isStandingsPlaceholder = item.Title === "STANDINGS" && (!playerIDs || playerIDs.length === 0);
                                                   const isTeamsPlaceholder = (item.Title === "TEAMS" || item.Title === "Teams") && (!playerIDs || playerIDs.length === 0);
                                                   
                                                   console.log("Playlist LOAD 1 - Item:", {
                                                      title: item.Title,
                                                      playerIDsLength: playerIDs?.length,
                                                      isStandingsPlaceholder,
                                                      isTeamsPlaceholder
                                                   });
                                                   
                                                   if (isStandingsPlaceholder) {
                                                      // Load standings using the placeholder's settings
                                                      const roundId = item.StandingsId !== undefined && item.StandingsId !== null ? item.StandingsId : selectedStandingsRound || 0;
                                                      const archetype = item.Archetype !== undefined && item.Archetype !== null ? item.Archetype : selectedArchetype;
                                                      const rows = item.Rows || selectedRows;
                                                      const columns = item.Columns || selectedColumns;
                                                      
                                                      // Get players and load to viewer
                                                      socket.emit("getCustomLeaderboardAllPlayers", roundId, (allPlayersData) => {
                                                         if (allPlayersData && allPlayersData.length > 0) {
                                                            const playerIds = allPlayersData.map((p) => p.id || p.PlayerId).filter(Boolean);
                                                            if (playerIds.length > 0) {
                                                               socket.emit("loadCustomLeaderboardPlayersToViewer", {
                                                                  viewerId: 1,
                                                                  roundId: roundId,
                                                                  playerIds: playerIds,
                                                                  archetype: archetype,
                                                                  columns: columns,
                                                                  rows: rows
                                                               });
                                                               updatePlaylistIndex(index);
                                                            }
                                                         }
                                                      });
                                                   } else if (isTeamsPlaceholder) {
                                                      // Load teams using the placeholder's settings
                                                      const roundId = item.StandingsId !== undefined && item.StandingsId !== null ? item.StandingsId : selectedStandingsRound || 0;
                                                      const archetype = item.Archetype !== undefined && item.Archetype !== null ? item.Archetype : selectedArchetype;
                                                      const rows = item.Rows || selectedRows;
                                                      const columns = item.Columns || selectedColumns;
                                                      
                                                      // Call handleLoadAllTeams with override settings from placeholder
                                                      handleLoadAllTeams(1, {
                                                         roundId: roundId,
                                                         archetype: archetype,
                                                         rows: rows,
                                                         columns: columns
                                                      });
                                                      
                                                      updatePlaylistIndex(index);
                                                   } else {
                                                      viewerLoad(1, item.id);
                                                      updatePlaylistIndex(index);
                                                   }
                                                }}
                                             >
                                                LOAD 1
                                             </Button>
                                             <Button
                                                variant='outlined'
                                                color='error'
                                                size='small'
                                                sx={{ py: 0.5, px: 1 }}
                                                onClick={() => {
                                                   if (window.confirm("Are you sure you want to remove this item from the playlist?")) {
                                                      handleRemoveFromPlaylist(item.id);
                                                   }
                                                }}
                                             >
                                                Remove
                                             </Button>
                                          </Stack>
                                       </TableCell>
                                    </TableRow>
                                 ))}
                              </>
                           ) : (
                              <TableRow>
                                 <TableCell colSpan={4} sx={{ py: 1 }}>
                                    <Typography variant='body2' sx={{ color: "#999" }}>
                                       Playlist is empty. Click ADD to add items from the right column.
                                    </Typography>
                                 </TableCell>
                              </TableRow>
                           )}
                        </TableBody>
                        </Table>
                     </Box>
                  </Box>

                  {/* Right Column - Available Items */}
                  <Box sx={{ width: { xs: "100%", md: "20%" }, minWidth: 0 }}>
                     <Typography variant='h6' sx={{ mb: 2, textTransform: "uppercase" }}>
                        Available Leaderboards
                     </Typography>
                     <Box sx={{ overflowX: 'auto', width: '100%' }}>
                        <Table variant='dashboard'>
                           <TableHead>
                              <TableRow>
                                 <TableCell sx={{ py: 0.5, fontSize: '0.875rem' }}>Title</TableCell>
                              </TableRow>
                           </TableHead>
                        <TableBody>
                           {availableItems.map((item) => {
                              const isInPlaylist = playlist.some(playlistItem => playlistItem.id === item.id);
                              // Color coding: orange for teams (Type 1), blue for storyboards (Type 0), green for standings (Type 2), yellow for teams placeholder (Type 3)
                              const borderColor = item.Type === 1 ? "rgba(255, 152, 0, 0.8)" : item.Type === 2 ? "rgba(76, 175, 80, 0.8)" : item.Type === 3 ? "rgba(255, 235, 59, 0.8)" : "rgba(33, 150, 243, 0.8)";
                              return (
                                 <TableRow
                                    key={item.id}
                                    sx={{
                                       opacity: isInPlaylist ? 0.2 : 1,
                                       borderLeft: `6px solid ${borderColor}`,
                                       "&:hover": {
                                          backgroundColor: isInPlaylist ? "transparent" : "#555",
                                       },
                                    }}
                                 >
                                    <TableCell sx={{ py: 0.5 }}>
                                       <Button
                                          onClick={() => handleAddToPlaylist(item)}
                                          disabled={isInPlaylist}
                                          sx={{
                                             textTransform: 'none',
                                             fontWeight: "bold",
                                             color: isInPlaylist ? "#666" : "inherit",
                                             fontSize: '0.875rem',
                                             py: 0,
                                             px: 0,
                                             minWidth: 'auto',
                                             justifyContent: 'flex-start',
                                             "&:hover": {
                                                backgroundColor: isInPlaylist ? "transparent" : "rgba(255, 255, 255, 0.1)",
                                             },
                                          }}
                                       >
                                          {item.Title || "-NO TITLE-"}
                                       </Button>
                                    </TableCell>
                                 </TableRow>
                              );
                           })}
                           {availableItems.length === 0 && (
                              <TableRow>
                                 <TableCell colSpan={1} sx={{ py: 0.5 }}>
                                    <Typography variant='body2' sx={{ color: "#999", fontSize: '0.875rem' }}>
                                       No available leaderboards
                                    </Typography>
                                 </TableCell>
                              </TableRow>
                           )}
                        </TableBody>
                        </Table>
                     </Box>
                  </Box>
               </Stack>
            </TabPanel>

            <TabPanel value={activeTab} index={1}>
               <Table variant='dashboard' sx={{ maxWidth: 1500 }}>
                  <TableHead>
                     <TableRow>
                        <TableCell sx={{ py: 1 }}>Title</TableCell>
                        <TableCell sx={{ py: 1 }}>Players</TableCell>
                        <TableCell sx={{ py: 1 }}>Standings</TableCell>
                        <TableCell align='right' width='400' sx={{ py: 1 }}>
                           {parent != "producer" && (
                              <Button onClick={add} variant='contained' color='error' size='small'>
                                 + ADD NEW
                              </Button>
                           )}
                        </TableCell>
                     </TableRow>
                  </TableHead>
                  <TableBody>
                     {customRows.map((row) => (
                        <React.Fragment key={"slideRow" + row.id}>
                           <TableRow>
                              <TableCell width='350' sx={{ pl: 2, py: 1 }}>
                                 <Stack spacing={0.5}>
                                    <TextInput
                                       color='#333'
                                       value={row.Title ? row.Title : "-NO TITLE-"}
                                       callback={(value) =>
                                          update(row.id, { Title: value })
                                       }
                                    />
                                    <SelectInput
                                       label='ROWS'
                                       size='small'
                                       options={[4, 5, 6, 7, 8, 9, 10]}
                                       value={row.Rows}
                                       callback={(value) =>
                                          update(row.id, { Rows: value })
                                       }
                                    />
                                    <SelectInput
                                       label='COLUMNS'
                                       size='small'
                                       value={row.Columns}
                                       options={[1, 2]}
                                       callback={(value) =>
                                          update(row.id, { Columns: value })
                                       }
                                    />
                                    {row.Columns < 2 && (
                                          <SelectInput
                                             label='SHOW'
                                             size='small'
                                             value={row.Archetype}
                                             options={[{value: 0, label: "--"}, {value: 1, label: "Archetype"}, {value: 2, label: "Team"}, {value: 3, label: "Strixhaven School"}]}
                                             callback={(value) => update(row.id, { Archetype: value })}
                                          />
                                    )}
                                 </Stack>
                              </TableCell>
                              <TableCell sx={{ position: "relative", py: 1 }}>
                                 <Stack spacing={1}>
                                    <Button
                                       variant='outlined'
                                       color='warning'
                                       size='small'
                                       sx={{ py: 0.5 }}
                                       onClick={() => {
                                          editRow === row.id
                                             ? setEditRow()
                                             : setEditRow({
                                                Title: row.Title,
                                                id: row.id,
                                                PlayerIDs: row.PlayerIDs,
                                             });
                                       }}
                                    >
                                       Edit Players
                                    </Button>
                                    <Box
                                       sx={{
                                          width: "100%",
                                          maxHeight: 100,
                                          overflowY: "auto",
                                          overflowX: "hidden",
                                          fontSize: "0.875rem",
                                       }}
                                    >
                                       <b>
                                          Total Players:{" "}
                                          {JSON.parse(row.PlayerIDs).length}
                                       </b>
                                       {_.filter(allPlayers, (o) => {
                                          return row.PlayerIDs.includes(o.id);
                                       }).map((player) => {
                                          return (
                                             <Box
                                                key={player.id}
                                                sx={{ whiteSpace: "nowrap", fontSize: "0.75rem" }}
                                             >
                                                {player.LastName +
                                                   ", " +
                                                   player.FirstName}
                                             </Box>
                                          );
                                       })}
                                    </Box>
                                 </Stack>
                              </TableCell>
                              <TableCell sx={{ py: 1 }}>
                                 <StandingsSelect
                                    selected={
                                       row.StandingsId ? row.StandingsId : 0
                                    }
                                    callback={(e) =>
                                       handleChangeStandings(row.id, e)
                                    }
                                 />
                              </TableCell>
                              <TableCell
                                 align='right'
                                 sx={{ whiteSpace: "nowrap", py: 1 }}
                              >
                                 <Stack direction='row' spacing={0.5}>
                                    {parent != "producer" && (
                                       <>
                                          <Button
                                             variant='outlined'
                                             color='success'
                                             fullWidth
                                             size='small'
                                             sx={{ py: 0.5, px: 1 }}
                                             id={row.id}
                                             onClick={(e) => handleLoadSlide(1, e)}
                                          >
                                             LOAD 1
                                          </Button>

                                          <Button
                                             variant='outlined'
                                             color='success'
                                             fullWidth
                                             size='small'
                                             sx={{ py: 0.5, px: 1 }}
                                             id={row.id}
                                             onClick={(e) => handleLoadSlide(2, e)}
                                          >
                                             LOAD 2
                                          </Button>

                                          <Button
                                             variant='outlined'
                                             color='error'
                                             fullWidth
                                             size='small'
                                             sx={{ py: 0.5, px: 1 }}
                                             startIcon={<DeleteIcon />}
                                             onClick={() =>
                                                handleDelete(row.id, row.Title)
                                             }
                                          >
                                             DELETE
                                          </Button>
                                       </>
                                    )}
                                 </Stack>
                              </TableCell>
                           </TableRow>
                        </React.Fragment>
                     ))}
                  </TableBody>
               </Table>
            </TabPanel>

            <TabPanel value={activeTab} index={2}>
               <Stack direction='row' spacing={2} sx={{ mb: 2 }}>
                  <Button
                     variant='outlined'
                     color='warning'
                     sx={{ whiteSpace: "nowrap", px: 4 }}
                     onClick={(e) => refreshTeams()}
                     size='small'
                  >
                     REFRESH TEAM PLAYERS
                  </Button>
                  <Button
                     variant='outlined'
                     color='warning'
                     sx={{ whiteSpace: "nowrap", px: 4 }}
                     onClick={(e) => importTeams()}
                     size='small'
                  >
                     REIMPORT TEAMS
                  </Button>
               </Stack>
               <Table variant='dashboard' sx={{ maxWidth: 1500 }}>
                  <TableHead>
                     <TableRow>
                        <TableCell sx={{ py: 1 }}>Title</TableCell>
                        <TableCell sx={{ py: 1 }}>Players</TableCell>
                        <TableCell sx={{ py: 1 }}>Standings</TableCell>
                        <TableCell align='right' width='400' sx={{ py: 1 }}>
                           {parent != "producer" && (
                              <Button onClick={add} variant='contained' color='error' size='small'>
                                 + ADD NEW
                              </Button>
                           )}
                        </TableCell>
                     </TableRow>
                  </TableHead>
                  <TableBody>
                     {teamRows.map((row) => (
                        <React.Fragment key={"slideRow" + row.id}>
                           <TableRow>
                              <TableCell width='350' sx={{ pl: 2, py: 1 }}>
                                 <Stack spacing={0.5}>
                                    <Box
                                       sx={{
                                          fontWeight: "bold",
                                          fontSize: "1.2em",
                                          color: !row.Title ? "#666" : "#333",
                                       }}
                                    >
                                       {row.Title ? row.Title : "-NO TITLE-"}
                                    </Box>
                                    <SelectInput
                                       label='ROWS'
                                       size='small'
                                       options={[4, 5, 6, 7, 8, 9, 10]}
                                       value={row.Rows}
                                       callback={(value) =>
                                          update(row.id, { Rows: value })
                                       }
                                    />
                                    <SelectInput
                                       label='COLUMNS'
                                       size='small'
                                       value={row.Columns}
                                       options={[1, 2]}
                                       callback={(value) =>
                                          update(row.id, { Columns: value })
                                       }
                                    />
                                    {row.Columns < 2 && (
                                       <SelectInput
                                          label='SHOW'
                                          size='small'
                                          value={row.Archetype}
                                          options={[{value: 0, label: "--"}, {value: 1, label: "Archetype"}, {value: 2, label: "Team"}, {value: 3, label: "Strixhaven School"}]}
                                          callback={(value) => update(row.id, { Archetype: value })}
                                       />
                                    )}
                                 </Stack>
                              </TableCell>
                              <TableCell sx={{ position: "relative", py: 1 }}>
                                 <Box
                                    sx={{
                                       width: "100%",
                                       maxHeight: 100,
                                       overflowY: "auto",
                                       overflowX: "hidden",
                                       fontSize: "0.875rem",
                                    }}
                                 >
                                    <b>
                                       Total Players:{" "}
                                       {JSON.parse(row.PlayerIDs).length}
                                    </b>
                                    {_.filter(allPlayers, (o) => {
                                       return row.PlayerIDs.includes(o.id);
                                    }).map((player) => {
                                       return (
                                          <Box
                                             key={player.id}
                                             sx={{ whiteSpace: "nowrap", fontSize: "0.75rem" }}
                                          >
                                             {player.LastName +
                                                ", " +
                                                player.FirstName}
                                          </Box>
                                       );
                                    })}
                                 </Box>
                              </TableCell>
                              <TableCell sx={{ py: 1 }}>
                                 <StandingsSelect
                                    selected={
                                       row.StandingsId ? row.StandingsId : 0
                                    }
                                    callback={(e) =>
                                       handleChangeStandings(row.id, e)
                                    }
                                 />
                              </TableCell>
                              <TableCell
                                 align='right'
                                 sx={{ whiteSpace: "nowrap", py: 1 }}
                              >
                                 <Stack direction='row' spacing={0.5}>
                                    {parent != "producer" && (
                                       <>
                                          <Button
                                             variant='outlined'
                                             color='success'
                                             fullWidth
                                             size='small'
                                             sx={{ py: 0.5, px: 1 }}
                                             id={row.id}
                                             onClick={(e) => handleLoadSlide(1, e)}
                                          >
                                             LOAD 1
                                          </Button>

                                          <Button
                                             variant='outlined'
                                             color='success'
                                             fullWidth
                                             size='small'
                                             sx={{ py: 0.5, px: 1 }}
                                             id={row.id}
                                             onClick={(e) => handleLoadSlide(2, e)}
                                          >
                                             LOAD 2
                                          </Button>
                                       </>
                                    )}
                                 </Stack>
                              </TableCell>
                           </TableRow>
                        </React.Fragment>
                     ))}
                  </TableBody>
               </Table>
            </TabPanel>

            <TabPanel value={activeTab} index={3}>
               <Stack spacing={2} sx={{ mt: 2 }}>
                  <Box>
                     <Stack direction='row' spacing={2} alignItems='center' justifyContent='space-between' sx={{ backgroundColor: "#fff", p: 2, borderRadius: 1 }}>
                        
                        <Stack direction='row' spacing={2} alignItems='center' width='80%'>

                        <StandingsSelect
                              selected={selectedStandingsRound}
                              callback={handleStandingsChange}
                           />
                           <Select
                              fullWidth
                              size='small'
                              value={selectedRows}
                              onChange={(e) => setSelectedRows(Number(e.target.value))}
                              displayEmpty
                           >
                              <MenuItem value={4}>4 Rows</MenuItem>
                              <MenuItem value={6}>6 Rows</MenuItem>
                              <MenuItem value={8} selected>8 Rows</MenuItem>
                              <MenuItem value={10}>10 Rows</MenuItem>
                           </Select>

                           <Select
                              fullWidth
                              size='small'
                              value={selectedColumns}
                              onChange={(e) => setSelectedColumns(Number(e.target.value))}
                              displayEmpty
                           >
                              <MenuItem value={1} selected>1 Column</MenuItem>
                              <MenuItem value={2}>2 Columns</MenuItem>
                           </Select>

                           {selectedColumns === 1 && (
                              <Select
                                 fullWidth
                                 size='small'
                                 value={selectedArchetype}
                                 onChange={(e) => setSelectedArchetype(Number(e.target.value))}
                                 displayEmpty
                              >
                                 <MenuItem value={0}>--</MenuItem>
                                 <MenuItem value={1}>Archetype</MenuItem>
                                 <MenuItem value={2}>Team</MenuItem>
                                 <MenuItem value={3}>Strixhaven School</MenuItem>
                              </Select>
                           )}
                        </Stack>
                        <Stack direction='row' spacing={1}>
                           <Button
                              variant='outlined'
                              color='success'
                              size='small'
                              sx={{ py: 0.5, px: 2 }}
                              onClick={() => handleLoadAllPlayers(1)}
                              disabled={!standings || standings.length === 0}
                           >
                              LOAD 1
                           </Button>
                           <Button
                              variant='outlined'
                              color='success'
                              size='small'
                              sx={{ py: 0.5, px: 2 }}
                              onClick={() => handleLoadAllPlayers(2)}
                              disabled={!standings || standings.length === 0}
                           >
                              LOAD 2
                           </Button>
                        </Stack>
                     </Stack>
                  </Box>
                  <Box>
                     {standings && standings.length > 0 ? (
                        <DataGrid
                           data={standings}
                           type='standings'
                           disableColumnFilter={false}
                           height={600}
                        />
                     ) : (
                        <Typography variant='body2' sx={{ color: "#999", py: 4 }}>
                           {selectedStandingsRound === 0 || selectedStandingsRound === undefined || selectedStandingsRound === null
                              ? "Loading most recent standings..."
                              : "No standings data available for the selected round"}
                        </Typography>
                     )}
                  </Box>
               </Stack>
            </TabPanel>

            <TabPanel value={activeTab} index={4}>
               <Stack spacing={2} sx={{ mt: 2 }}>
                  <Box>
                     <Stack direction='row' spacing={2} alignItems='center' justifyContent='space-between' sx={{ backgroundColor: "#fff", p: 2, borderRadius: 1 }}>
                        
                        <Stack direction='row' spacing={2} alignItems='center' width='80%'>

                        <StandingsSelect
                              selected={selectedStandingsRound}
                              callback={handleStandingsChange}
                           />
                           <Select
                              fullWidth
                              size='small'
                              value={selectedRows}
                              onChange={(e) => setSelectedRows(Number(e.target.value))}
                              displayEmpty
                           >
                              <MenuItem value={4}>4 Rows</MenuItem>
                              <MenuItem value={6}>6 Rows</MenuItem>
                              <MenuItem value={8} selected>8 Rows</MenuItem>
                              <MenuItem value={10}>10 Rows</MenuItem>
                           </Select>

                           <Select
                              fullWidth
                              size='small'
                              value={selectedColumns}
                              onChange={(e) => setSelectedColumns(Number(e.target.value))}
                              displayEmpty
                           >
                              <MenuItem value={1} selected>1 Column</MenuItem>
                              <MenuItem value={2}>2 Columns</MenuItem>
                           </Select>
                        </Stack>
                        <Stack direction='row' spacing={1}>
                           <Button
                              variant='outlined'
                              color='success'
                              size='small'
                              sx={{ py: 0.5, px: 2 }}
                              onClick={() => handleLoadAllTeams(1)}
                              disabled={!teamStandings || teamStandings.length === 0}
                           >
                              LOAD 1
                           </Button>
                           <Button
                              variant='outlined'
                              color='success'
                              size='small'
                              sx={{ py: 0.5, px: 2 }}
                              onClick={() => handleLoadAllTeams(2)}
                              disabled={!teamStandings || teamStandings.length === 0}
                           >
                              LOAD 2
                           </Button>
                        </Stack>
                     </Stack>
                  </Box>
                  <Box>
                     {teamStandings && teamStandings.length > 0 ? (
                        <DataGrid
                           data={teamStandings}
                           type='teamStandings'
                           disableColumnFilter={false}
                           height={600}
                        />
                     ) : (
                        <Typography variant='body2' sx={{ color: "#999", py: 4 }}>
                           {selectedStandingsRound === 0 || selectedStandingsRound === undefined || selectedStandingsRound === null
                              ? "Loading most recent team standings..."
                              : "No team standings data available for the selected round"}
                        </Typography>
                     )}
                  </Box>
               </Stack>
            </TabPanel>

            <TabPanel value={activeTab} index={5}>
               <Stack spacing={2} sx={{ mt: 2 }}>
                  <Box>
                     <Stack direction='row' spacing={2} alignItems='center' justifyContent='space-between' sx={{ backgroundColor: "#fff", p: 2, borderRadius: 1 }}>

                        <Stack direction='row' spacing={2} alignItems='center' width='80%'>

                           <StandingsSelect
                              selected={selectedStandingsRound}
                              callback={handleStandingsChange}
                           />
                           <Select
                              fullWidth
                              size='small'
                              value={selectedRows}
                              onChange={(e) => setSelectedRows(Number(e.target.value))}
                              displayEmpty
                           >
                              <MenuItem value={4}>4 Rows</MenuItem>
                              <MenuItem value={6}>6 Rows</MenuItem>
                              <MenuItem value={8} selected>8 Rows</MenuItem>
                              <MenuItem value={10}>10 Rows</MenuItem>
                           </Select>

                           <Select
                              fullWidth
                              size='small'
                              value={selectedColumns}
                              onChange={(e) => setSelectedColumns(Number(e.target.value))}
                              displayEmpty
                           >
                              <MenuItem value={1} selected>1 Column</MenuItem>
                              <MenuItem value={2}>2 Columns</MenuItem>
                           </Select>
                        </Stack>
                        <Stack direction='row' spacing={1}>
                           <Button
                              variant='outlined'
                              color='success'
                              size='small'
                              sx={{ py: 0.5, px: 2 }}
                              onClick={() => handleLoadStrixhavenTeamsToViewer(1)}
                              disabled={!strixhavenTeamStandings || strixhavenTeamStandings.length === 0}
                           >
                              LOAD 1
                           </Button>
                           <Button
                              variant='outlined'
                              color='success'
                              size='small'
                              sx={{ py: 0.5, px: 2 }}
                              onClick={() => handleLoadStrixhavenTeamsToViewer(2)}
                              disabled={!strixhavenTeamStandings || strixhavenTeamStandings.length === 0}
                           >
                              LOAD 2
                           </Button>
                        </Stack>
                     </Stack>
                  </Box>
                  <Box>
                     {strixhavenTeamStandings && strixhavenTeamStandings.length > 0 ? (
                        <DataGrid
                           data={strixhavenTeamStandings}
                           type='teamStandings'
                           teamStandingsVariant='strixhavenSchools'
                           disableColumnFilter={false}
                           height={600}
                        />
                     ) : (
                        <Typography variant='body2' sx={{ color: "#999", py: 4 }}>
                           {selectedStandingsRound === 0 || selectedStandingsRound === undefined || selectedStandingsRound === null
                              ? "Loading Strixhaven school standings..."
                              : "No Strixhaven school data for the selected round (players need STRIXHAVEN_SCHOOL set)"}
                        </Typography>
                     )}
                  </Box>
               </Stack>
            </TabPanel>
         </Box>

         {editRow && (
            <Modal
               open={true}
               onClose={() => setEditRow(null)}
               aria-labelledby='modal-modal-title'
               aria-describedby='modal-modal-description'
            >
               <Box sx={style}>
                  <Button
                     aria-label='close'
                     variant='outlined'
                     color='secondary'
                     sx={{
                        position: "absolute",
                        top: 10,
                        right: 10,
                        zIndex: 100,
                     }}
                     startIcon={<CloseIcon />}
                     onClick={() => setEditRow(null)}
                  >
                     Close
                  </Button>

                  <Typography
                     variant='h5'
                     component='div'
                     sx={{
                        textTransform: "uppercase",
                     }}
                  >
                     Storyboards Players
                  </Typography>
                  <Typography
                     variant='h4'
                     component='div'
                     sx={{
                        textTransform: "uppercase",
                        mb: 2,
                     }}
                  >
                     {editRow.Title}
                  </Typography>

                  <Box>
                     {console.log(allPlayers)}
                     <PlayerSelect
                        callback={(value) =>
                           update(editRow.id, { PlayerIDs: value })
                        }
                        selectedRows={editRow.PlayerIDs}
                        rows={allPlayers}
                     />
                  </Box>
               </Box>
            </Modal>
         )}

         {notification && (
            <NotificationWidget
               notification={notification.message}
               key={"notification" + notification.date}
            />
         )}
      </Wrapper>
   );
}
